import clsx from "clsx";
import React, { ReactNode, useEffect } from "react";
import { createPortal } from "react-dom";
import { twMerge } from "tailwind-merge";

function Model({ children, className, ...props }: any) {
  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);

  return createPortal(
    <div
      className="fixed left-0 top-0 z-[10014] flex h-full w-full items-center justify-center "
      style={{ backgroundColor: "rgba(0, 0, 0, 0.6)" }}
    >
      <div
        className={twMerge(
          clsx(
            "max-h-[80%] overflow-y-auto rounded-xxl border-2 border-white bg-white p-6 max-sm:w-4/5",
            className
          )
        )}
        {...props}
      >
        {children}
      </div>
    </div>,
    document.body
  );
}

export default Model;
